import { msalInstance } from "..";
import { loginRequest } from "../helpers/authConfig";
import moment from 'moment';

const ua = window.navigator.userAgent;
const isSafari = ua.indexOf("Safari/") > 0 && ua.indexOf("Edge/") === -1 && ua.indexOf("Edg/") === -1 && ua.indexOf("Chrome/") === -1;

export async function getAuthenticatedHeaders(headers, resolveWhenNotAuthenticated) {
    headers = headers || {};

    const isAlmostExpired = () => {
        const account = msalInstance.getActiveAccount();
        if (!!account && !!account.idTokenClaims &&
            new Date(account.idTokenClaims.exp * 1000) > new Date()) {

            var exipringSoonTime = moment().add('10', 'm');
            var expireTimeMoment = moment(account.idTokenClaims.exp * 1000);
            //console.log(expireTimeMoment.diff(exipringSoonTime, 'minutes') + ' minutes till renew attempt');
            if (expireTimeMoment < exipringSoonTime) {
                return true
            }
        }

        return false;
    }

    const hasPlentyOfSession = () => {
        const account = msalInstance.getActiveAccount();
        if (!!account && !!account.idTokenClaims &&
            new Date(account.idTokenClaims.exp * 1000) > new Date()) {

            // 30 minutes is arbitrary plenty of session marker point
            var exipringSoonTime = moment().add('30', 'm');
            var expireTimeMoment = moment(account.idTokenClaims.exp * 1000);
            //console.log(expireTimeMoment.diff(exipringSoonTime, 'minutes') + ' minutes till renew attempt');
            if (expireTimeMoment < exipringSoonTime) {
                return true
            }
        }

        return false;
    }

    const getExistingToken = () => {
        const account = msalInstance.getActiveAccount();
        if (!!account && !!account.idTokenClaims &&
            new Date(account.idTokenClaims.exp * 1000) > new Date()) {
            return account.idToken;
        }

        return null;
    }

    const account = msalInstance.getActiveAccount();
    if (!account && resolveWhenNotAuthenticated) {
        return await Promise.resolve(headers);
    }

    try {
        // Safari behaves badly if we call acquireTokenSilent while MSAL is initializing. MSAL
        // doesn't give us a way to know if it's ready yet so we avoid calling it for safari until
        // the session is almost expired. Other browsers get a console warning when this happens
        // but there is realistically no need to get a new one that often so in these cases we
        // just use the cached token instead of requesting a new one (that will just be the same
        // as the cached one most of the time)
        if ((isSafari && !isAlmostExpired() && !!getExistingToken()) || hasPlentyOfSession()) {
            headers = { ...headers, 'Authorization': 'Bearer ' + getExistingToken() };
        } else {
            const response = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account
            });
            headers = { ...headers, 'Authorization': 'Bearer ' + response.idToken };
        }
    }
    catch (exception) {
        msalInstance.loginRedirect(loginRequest);
    }

    return await Promise.resolve(headers);
}

export function simpleFetcher(url) {
    return getAuthenticatedHeaders().then((headers) => {
        return fetch(url, { headers })
            .then(response => response.json())
    });
}